/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Closedeal_Errormessage3Inputs */

const en_coinvestments_tracking_closedeal_errormessage3 = /** @type {(inputs: Coinvestments_Tracking_Closedeal_Errormessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to close opportunity`)
};

/**
* | output |
* | --- |
* | "Failed to close opportunity" |
*
* @param {Coinvestments_Tracking_Closedeal_Errormessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_closedeal_errormessage3 = /** @type {((inputs?: Coinvestments_Tracking_Closedeal_Errormessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Closedeal_Errormessage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_closedeal_errormessage3(inputs)
});
export { coinvestments_tracking_closedeal_errormessage3 as "coInvestments_tracking_closeDeal_errorMessage" }